import { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import { TableContext } from 'src/app/providers/TableProvider';

export const useCheckAddRow = (
  setFullWidth: Dispatch<SetStateAction<boolean>>,
  canWrite: boolean,
) => {
  const { addEmptyRows, resetTable } = useContext(TableContext);

  const checkAddRow = e => {
    if (e.key === 'F11') {
      setFullWidth(prev => !prev);
    }

    if (e.key === 'Escape') {
      resetTable();
    }

    if (canWrite && ((e.ctrlKey && e.keyCode === 13) || e.keyCode === 45)) {
      addEmptyRows(1);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', checkAddRow);

    return () => {
      document.removeEventListener('keydown', checkAddRow);
    };
  }, [canWrite]);
};
